import { render } from "./LearnWhyContent.vue?vue&type=template&id=18530f08&scoped=true"
import script from "./LearnWhyContent.vue?vue&type=script&lang=js"
export * from "./LearnWhyContent.vue?vue&type=script&lang=js"

import "./LearnWhyContent.vue?vue&type=style&index=0&id=18530f08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18530f08"]])

export default __exports__